import React from 'react';
import clsx from 'clsx';
import { APP_COLORS } from '@/config/colors';

export interface OrderCanceledViewProps {
  className?: string;
  /**
   * E-mail kontaktowy marki (z API), na który klient ma się zgłosić z pytaniami.
   * Gdy brak — sekcja kontaktu nie jest pokazywana.
   */
  contactEmail?: string;
}

export const OrderCanceledView: React.FC<OrderCanceledViewProps> = ({
  className,
  contactEmail,
}) => {
  return (
    <div className={clsx('flex w-full justify-center bg-white', className)}>
      <section className="container py-8">
        <div
          className="rounded-[10px] border-2 p-8 text-center"
          style={{ borderColor: APP_COLORS.gray[300] }}
        >
          <div
            className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full"
            style={{ backgroundColor: APP_COLORS.gray[100] }}
          >
            <svg
              width="32"
              height="32"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                stroke={APP_COLORS.grayText}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M15 9L9 15"
                stroke={APP_COLORS.grayText}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M9 9L15 15"
                stroke={APP_COLORS.grayText}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <h2 className="mb-2 font-archivo text-xl font-bold text-text-primary">
            Zamówienie anulowane
          </h2>
          <p className="font-inter text-sm text-grayText">
            To zamówienie zostało anulowane i nie jest już aktywne.
          </p>
          {contactEmail && (
            <p className="mt-4 font-inter text-sm text-grayText">
              W razie pytań skontaktuj się z nami:{' '}
              <a
                href={`mailto:${contactEmail}`}
                className="font-medium text-primary-500 hover:underline"
              >
                {contactEmail}
              </a>
            </p>
          )}
        </div>
      </section>
    </div>
  );
};

export default OrderCanceledView;
